@if (selectedCases.length && taskType === 'tasks') {
    <div class="h-4rem border-bottom-1 surface-border flex justify-content-start align-items-center px-4 py-3">
        <span class="m-2 text-bold">{{ selectedCases.length }}</span
        ><span> {{ 'default-cm-selected' | translate: 'Selected' }} </span>
        <p-button
            class="pl-2"
            label="{{ 'default-cm-reassign' | translate: 'Reassign' }}"
            [text]="true"
            (click)="showReassignModal()"
        ></p-button>
    </div>
}
@if (selectedCases.length && taskType === 'signals') {
    <div class="h-4rem border-bottom-1 surface-border flex justify-content-start align-items-center px-4 py-3">
        <span class="m-2 text-bold">{{ selectedCases.length }}</span
        ><span>{{ 'default-cm-selected' | translate: 'Selected' }}</span>
        <p-button
            class="pl-2"
            label="{{ 'default-cm-sendSignal' | translate: 'Send Signal' }}"
            [text]="true"
            (click)="showSendSignalModal()"
        ></p-button>
    </div>
}
@if (selectedCases.length && taskType === 'recovery') {
    <div class="h-4rem border-bottom-1 surface-border flex justify-content-start align-items-center px-4 py-3">
        <span class="m-2 text-bold">{{ selectedCases.length }}</span
        ><span>{{ 'default-cm-selected' | translate: 'Selected' }}</span>
        <p-button
            class="pl-2"
            label="{{ 'default-cm-re-attempt' | translate: 'Re-attempt' }}"
            [disabled]="isFirstTime"
            [text]="true"
            (click)="showRecoveryDialog()"
        ></p-button>
    </div>
}
@if (allColumnsHideable) {
    <p class="text-center">{{ 'default-cm-noColumns' | translate: 'No Columns Configured' }}</p>
} @else {
    <p-table
        #tableRef
        styleClass="alpha-border-1 border-x-none border-top-none overflow-hidden"
        [value]="caseData"
        [(selection)]="selectedCases"
        [scrollable]="true"
        scrollHeight="{{ filterOptions.totalCases == 0 ? '' : 'flex' }}"
        [ngClass]="inboxTableClass"
        [rowTrackBy]="_inboxService.trackByFunction"
    >
        <!-- table header start -->
        <ng-template pTemplate="header">
            <tr class="text-sm">
                <!-- all table row select-all checkbox  -->
                <th>
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                @for (column of currentTask.columns; track $index) {
                    @if (!column.hideable) {
                        <th [ariaColIndex]="$index" [attr.data-column-name]="column?.label | translateConfig">
                            <div class="flex align-items-center">
                                {{ column.label | translateConfig }}
                                <!-- sort icon (svg-img) start -->
                                @if (currentTask.sort && column.sort) {
                                    <span (click)="customSort(column)" class="cursor-pointer pt-1 sort-fill">
                                        @if (!sort[column.name]) {
                                            <img src="assets/icons/sort-icon.svg" alt="sort" />
                                        }
                                        @if (sort[column.name] && sortStatus === 'desc') {
                                            <img src="assets/icons/sort-asc-icon.svg" alt="sort" />
                                        }
                                        @if (sort[column.name] && sortStatus === 'asc') {
                                            <img src="assets/icons/sort-desc-icon.svg" alt="sort" />
                                        }
                                    </span>
                                }
                                <!-- sort icon (svg-img) end -->
                            </div>
                        </th>
                    }
                }
            </tr>
        </ng-template>
        <!-- table header end -->

        <!-- table body start -->
        <ng-template pTemplate="body" let-caseData let-index="rowIndex">
            <tr class="text-md font-normal" [attr.aria-rowindex]="index">
                <td class="w-4rem">
                    <p-tableCheckbox
                        [disabled]="caseData?.taskInstance?.recoveryStatus === 'Processing'"
                        [value]="caseData"
                    ></p-tableCheckbox>
                </td>
                @for (column of currentTask.columns; track $index) {
                    @if (column.type == 'icon') {
                        <td class="cursor-pointer" (click)="openVariableDialog(caseData, column.name)">
                            <i class="pi pi-eye"></i>
                        </td>
                    }
                    @if (!column.hideable && column.type !== 'icon') {
                        <td
                            class="cursor-pointer"
                            [ariaColIndex]="$index"
                            [attr.data-column-name]="translateInboxLabel(column?.label)"
                            [attr.data-row-index]="index"
                            [attr.data-value]="caseDataTableMappings[index]?.get(column)"
                        >
                            <div copyOnHover>
                                {{ caseDataTableMappings[index]?.get(column) }}
                            </div>
                        </td>
                    }
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="100%">
                    <div class="flex flex-column justify-content-center align-items-center">
                        <img class="w-15rem p-3" src="assets/icons/no-task-found.svg" alt="" />
                    </div>
                </td>
            </tr>
        </ng-template>
        <!-- table body end -->
    </p-table>
}
